import AccountsApiPaths from '../endpoints'
import axios from 'axios'
import VisitsApiPaths from 'Application/Visits/Constants/VisitsApiPaths'
import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from 'Services/httpConfig'
import { setSignatureCancelToken, setSignatureUploadProgress } from 'Application/Account/store'
import type { AssignSignature, UploadVisitFile } from './account.types'

export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['UserProfile', 'ExpertFields', 'AccessList'],
  endpoints: (builder) => ({
    // ---------------- Assign Signature ----------------
    assignSignature: builder.mutation<AssignSignature['RESULT'], AssignSignature['ARG']>({
      query: (data) => ({
        url: AccountsApiPaths.AssignSignature,
        method: 'PUT',
        data,
      }),
      invalidatesTags: ['UserProfile', 'ExpertFields', 'AccessList'],
    }),

    // ---------------- Upload Visit File ----------------
    uploadVisitFile: builder.mutation<UploadVisitFile['RESULT'], UploadVisitFile['ARG']>({
      queryFn: async ({ file, fileName }, { dispatch }, _extraOptions, baseQuery) => {
        const formData = new FormData()
        formData.append('FileData', file, fileName)

        const source = axios.CancelToken.source()
        dispatch(setSignatureCancelToken(source))

        const res = await baseQuery({
          url: VisitsApiPaths.UploadVisitFile,
          method: 'POST',
          data: formData,
          timeout: 120000,
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progress: any) => {
            const { loaded, total } = progress
            const percentageProgress = Math.floor((loaded / total) * 100)
            dispatch(setSignatureUploadProgress(percentageProgress))
          },
        })

        return res.error ? { error: res.error } : { data: res.data as number }
      },
      // invalidatesTags: ['UserProfile', 'ExpertFields', 'AccessList'],
    }),
  }),
})

export const { useUploadVisitFileMutation, useAssignSignatureMutation } = accountApi
